import {dashboardData, bestSaleItems, latestOrders} from "../api/dashboard";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import {useQuery} from "@tanstack/react-query";
import PreloaderComponent from "../components/UI/PreloaderComponent";

const HomePage = () => {

  const {data: dashboard, isPending} = useQuery({
    queryKey:['dashboard'],
    queryFn: () => dashboardData()
  })

  const {data: bestItems} = useQuery({
    queryKey:['bestItems'],
    queryFn: () => bestSaleItems()
  })

  const {data: recentOrderItems} = useQuery({
    queryKey:['recentOrderItems'],
    queryFn: () => latestOrders()
  })



  setTimeout(()=>{
    window.$(".round").each(function() {
      var round = window.$(this);
      var roundRadius = round.find('circle').attr('r');
      var roundPercent = round.data('percent');
      var roundCircum = 2 * roundRadius * Math.PI;
      var roundDraw = roundPercent * roundCircum / 100;
      round.css('stroke-dasharray', roundDraw  + ' 999');
    });
  },500)

  ChartJS.register(
      CategoryScale,
      LinearScale,
      PointElement,
      LineElement,
      Title,
      Tooltip,
      Legend
  );

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top'  ,
      },
      title: {
        display: true,
        text: 'Summary Statistic',
      },
    },
  };
  const labels = ['Published Product', 'Total Sale', 'Order'];
  let data = null;
  if(dashboard) {
    data = {
      labels,
      datasets: [
        {
          label: 'Today',
          data: [dashboard.today_new_customer, dashboard.today_new_vendor, dashboard.today_new_product_published, dashboard.today_order_amount, dashboard.today_order_count, dashboard.today_visitors],
          borderColor: 'rgb(255, 193, 7)',
          backgroundColor: 'rgb(255, 193, 7)',
        },
        {
          label: 'Yesterday',
          data: [dashboard.yesterday_product_published, dashboard.yesterday_order_amount, dashboard.yesterday_order_count],
          borderColor: 'rgb(226, 78, 77)',
          backgroundColor: 'rgb(226, 78, 77)',
        },
        {
          label: '7 days ago ',
          data: [dashboard.seven_days_product_published, dashboard.seven_days_order_amount, dashboard.seven_days_order_count],
          borderColor: 'rgb(44, 166, 122)',
          backgroundColor: 'rgb(44, 166, 122)',
        },
        {
          label: '30 days ago ',
          data: [dashboard.thirty_days_product_published, dashboard.thirty_days_order_amount, dashboard.thirty_days_order_count],
          borderColor: 'rgb(6, 24, 56)',
          backgroundColor: 'rgb(6, 24, 56)',
        },
      ],
    };
  }
  let percentageChange= 0
  if (dashboard) {
    const todayAveragePrice = dashboard.product_today_average_price;
    const yesterdayAveragePrice = dashboard.product_yesterday_average_price;
    const percentageChange = ((todayAveragePrice - yesterdayAveragePrice) / yesterdayAveragePrice) * 100;
  }

  const formatNumber = (number) =>{
    let total = number
    total = total.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })

    return total;
  }


  return (
      <>
        {isPending && <PreloaderComponent /> }
        {dashboard && <>
          <div className="row">
            <div className="col">
              <div className="card mt_0 mini-stats">
                <div className="card_heading d_flex_btwn">
                  <span className="mr_5"><i className="font_16p fas fa-dollar-sign"></i> Order</span>
                  <span className="mr_5 dashboard_span_subheading cursor_pointer" title={'Total sale summary (exclude cancel and delete order).'}> <i className="fas fa-info-circle"></i></span>
                </div>
                <div className="card_body">
                  <div className="mini-stats-content">
                    <div className="inner">
                      <h2>${dashboard.total_sale ? formatNumber(dashboard.total_sale) : '0.00'}</h2>
                      <p>Sale</p>
                    </div>
                    <div className="inner">
                      <h2>{dashboard.total_order_count}</h2>
                      <p>Count</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card mt_0 mini-stats">
                <div className="card_heading d_flex_btwn">
                  <span className="mr_5"><i className="fas fa-cart-arrow-down"></i> Cart </span>
                  <span className="mr_5 dashboard_span_subheading cursor_pointer" title={'Total product pending on the cart'}>
                    <i className="fas fa-info-circle"></i>
                  </span>
                </div>
                <div className="card_body">
                  <div className="mini-stats-content">
                    <div className="inner">
                      <h2>{dashboard.total_carts}</h2>
                      <p>Total</p>
                    </div>
                    <div className="inner">
                      <h2>{dashboard.today_carts}</h2>
                      <p>Today</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card mt_0 mini-stats">
                <div className="card_heading d_flex_btwn">
                  <span className="mr_5"><i className="font_16p fas fa-box-open"></i> Product </span>
                  <span className="mr_5 dashboard_span_subheading cursor_pointer" title={'Store stock summary'}>
                    <i className="fas fa-info-circle"></i>
                  </span>
                </div>
                <div className="card_body">
                  <div className="mini-stats-content">
                    <div className="inner">
                      <h2>{dashboard.total_active_products_active}</h2>
                      <p>Active</p>
                    </div>
                    <div className="inner">
                      <h2>{dashboard.total_active_products_inactive}</h2>
                      <p>InActive</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card mt_0 mini-stats">
                <div className="card_heading">
              <span className="mr_5"><i className="font_16p fas fa-box-open"></i>
              </span> Response
                </div>
                <div className="card_body">
                  <div className="mini-stats-content">
                    <div className="inner">
                      <h2>0</h2>
                      <p>Cancelation</p>
                    </div>
                    <div className="inner">
                      <h2>0</h2>
                      <p>Return</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*  <div className="row">*/}
          {/*    <div className="col_3">*/}
          {/*      <div className="card mini-stats">*/}
          {/*        <div className="card_heading">*/}
          {/*<span className="mr_5">*/}
          {/*<i className="fas fa-calendar-week"></i>*/}
          {/*</span>*/}
          {/*          Today's Summary*/}
          {/*        </div>*/}
          {/*        <div className="card_body">*/}
          {/*          <div className="mini-stats-content">*/}
          {/*            <div className="inner">*/}
          {/*              <h2>{dashboard.today_new_product_published}</h2>*/}
          {/*              <p>Product Published</p>*/}
          {/*            </div>*/}
          {/*            <div className="inner">*/}
          {/*              <h2>${dashboard.today_order_amount ? dashboard.today_order_amount.toFixed(2) : '0.00'}</h2>*/}
          {/*              <p>Total Sale</p>*/}
          {/*            </div>*/}
          {/*          </div>*/}
          {/*        </div>*/}
          {/*        <div className="card_body">*/}
          {/*          <div className="mini-stats-content">*/}
          {/*            <div className="inner">*/}
          {/*              <h2>{dashboard.today_order_count}</h2>*/}
          {/*              <p>Order Count</p>*/}
          {/*            </div>*/}
          {/*          </div>*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*    <div className="col_3">*/}
          {/*      <div className="card mini-stats">*/}
          {/*        <div className="card_heading">*/}
          {/*<span className="mr_5">*/}
          {/*<i className="fas fa-calendar-week"></i>*/}
          {/*</span>*/}
          {/*          Yesterday Summary*/}
          {/*        </div>*/}
          {/*        <div className="card_body">*/}
          {/*          <div className="mini-stats-content">*/}
          {/*            <div className="inner">*/}
          {/*              <h2>{dashboard.yesterday_product_published}</h2>*/}
          {/*              <p>Product Published</p>*/}
          {/*            </div>*/}
          {/*            <div className="inner">*/}
          {/*              <h2>${dashboard.yesterday_order_amount ? dashboard.yesterday_order_amount.toFixed(2) : '0.00'}</h2>*/}
          {/*              <p>Total Sale</p>*/}
          {/*            </div>*/}
          {/*          </div>*/}
          {/*        </div>*/}
          {/*        <div className="card_body">*/}
          {/*          <div className="mini-stats-content">*/}
          {/*            <div className="inner">*/}
          {/*              <h2>{dashboard.yesterday_order_count}</h2>*/}
          {/*              <p>Order Count</p>*/}
          {/*            </div>*/}
          {/*          </div>*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*    <div className="col_3">*/}
          {/*      <div className="card mini-stats">*/}
          {/*        <div className="card_heading">*/}
          {/*<span className="mr_5">*/}
          {/*<i className="fas fa-calendar-week"></i>*/}
          {/*</span>*/}
          {/*          Statistic From 7 Days Ago*/}
          {/*        </div>*/}
          {/*        <div className="card_body">*/}
          {/*          <div className="mini-stats-content">*/}
          {/*            <div className="inner">*/}
          {/*              <h2>{dashboard.seven_days_product_published}</h2>*/}
          {/*              <p>Product Published</p>*/}
          {/*            </div>*/}
          {/*            <div className="inner">*/}
          {/*              <h2>${dashboard.seven_days_order_amount ? dashboard.seven_days_order_amount.toFixed(2) : '0.00'}</h2>*/}
          {/*              <p>Total Sale</p>*/}
          {/*            </div>*/}
          {/*          </div>*/}
          {/*        </div>*/}
          {/*        <div className="card_body">*/}
          {/*          <div className="mini-stats-content">*/}
          {/*            <div className="inner">*/}
          {/*              <h2>{dashboard.seven_days_order_count}</h2>*/}
          {/*              <p>Order Count</p>*/}
          {/*            </div>*/}
          {/*          </div>*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*    <div className="col_3">*/}
          {/*      <div className="card mini-stats">*/}
          {/*        <div className="card_heading">*/}
          {/*<span className="mr_5">*/}
          {/*<i className="fas fa-calendar-week"></i>*/}
          {/*</span>*/}
          {/*          Statistic From 30 Days Ago*/}
          {/*        </div>*/}
          {/*        <div className="card_body">*/}
          {/*          <div className="mini-stats-content">*/}
          {/*            <div className="inner">*/}
          {/*              <h2>{dashboard.thirty_days_product_published}</h2>*/}
          {/*              <p>Product Published</p>*/}
          {/*            </div>*/}
          {/*            <div className="inner">*/}
          {/*              <h2>${dashboard.thirty_days_order_amount ? dashboard.thirty_days_order_amount.toFixed(2) : '0.00'}</h2>*/}
          {/*              <p>Total Sale</p>*/}
          {/*            </div>*/}
          {/*          </div>*/}
          {/*        </div>*/}
          {/*        <div className="card_body">*/}
          {/*          <div className="mini-stats-content">*/}
          {/*            <div className="inner">*/}
          {/*              <h2>{dashboard.thirty_days_order_count}</h2>*/}
          {/*              <p>Order Count</p>*/}
          {/*            </div>*/}
          {/*          </div>*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}

          <div className="row">
            <div className="col_12">
              <div className="card dashboard_selling_stats">
                <div className="card_heading"> Selling</div>
                <div className="card_body">
                  <div className="row">
                    <div className="col_8">
                      <Line options={options} data={data} />
                    </div>
                    <div className="col_4 pl_0">
                      <div className="dashboard_selling_stats_content">
                        <div className="inner width_50_percent_imp">
                          <div className="inner_wrap">
                            <h2>Today Order Amt</h2>
                            <h1>

                              ${formatNumber(dashboard.today_order_amount)}
                              {dashboard.today_order_amount > dashboard.yesterday_order_amount ? (
                                  <span className="up">${(dashboard.today_order_amount - dashboard.yesterday_order_amount)?.toFixed(2)} <i className="fa fa-arrow-up"></i></span>
                              ) : (
                                  <span className="down">${(dashboard.today_order_amount - dashboard.yesterday_order_amount)?.toFixed(2)} <i className="fa fa-arrow-down"></i></span>
                              )}
                            </h1>
                            <p>Yesterday Order Amt: <span>${dashboard.yesterday_order_amount?.toFixed(2)}</span></p>
                          </div>
                        </div>
                        <div className="inner width_50_percent_imp">
                          <div className="inner_wrap border_none">
                            <h2>Total Orders</h2>
                            <h1>${dashboard.total_order_amount ? formatNumber(dashboard.total_order_amount) : '0.00'}</h1>
                          </div>
                        </div>
                        <div className="inner width_50_percent_imp">
                          <div className="inner_wrap">
                            <h2>AVG. Items Price</h2>
                            <h1>$ {dashboard.product_today_average_price? parseFloat(dashboard.product_today_average_price).toFixed(2) : '0.00'}
                              { dashboard.product_today_average_price > dashboard.product_yesterday_average_price ? (
                                  <span className="up">{percentageChange}% <i className="fa fa-arrow-up"></i></span>
                              ) : (
                                  <span className="down">{percentageChange}% <i className="fa fa-arrow-down"></i></span>
                              )}
                            </h1>
                            <p>Yesterday Order Amt: <span>${dashboard.product_yesterday_average_price ? dashboard.product_yesterday_average_price.toFixed(2) : '0.00'}</span></p>
                          </div>
                        </div>
                        <div className="inner width_50_percent_imp">
                          <div className="inner_wrap border_none">
                            <h2>AVG. Order Amount</h2>
                            <h1>${dashboard.order_amount_average ? dashboard.order_amount_average.toFixed(2) : '0.00'} {/*<span className="down">-8.24% <i className="fa fa-arrow-down"></i></span>*/}</h1>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>

          <div className="row mt_10">
            <div className="col_9">
              <div className="card best_items">
                <div className="card_heading d_flex_btwn">
                  <span>Best Items</span>
                  <span className="mr_5 dashboard_span_subheading cursor_pointer" title={'Consider total best sale product. If no sale product available then random item could be show'}>
                    <i className="fas fa-info-circle"></i>
                  </span>
                </div>
                <div className="card_body pb_5">
                  {bestItems && bestItems.length && <>
                    <div className="best_item_content">
                    {bestItems.map((item, index) => (
                    <div className="inner" key={index}>
                      <div className="inner_wrap">
                        <div className="img">
                          <span className="num">{index + 1}</span>
                          <img src={item.image_path} alt="" className="width_full" />
                        </div>
                        <div className="text">
                          <h2>{item.sku}</h2>
                          <h2>{item.total_sales_count ?? 0} <span>sales</span></h2>
                          <p className="border_top">Stocks: {item.available_quantity}</p>
                          <p>Amount : ${item.price}</p>
                        </div>
                      </div>
                    </div>
                    ))}
                  </div>
                  </>
                  }
                </div>
              </div>
            </div>
            <div className="col_3">
              <div className="card recent_orders">
                <div className="card_heading">
                  <span>Recent Order</span>
                  <span className="mr_5 dashboard_span_subheading cursor_pointer"
                        title={'Consider only latest 7 new order.'}>
                    <i className="fas fa-info-circle"></i>
                  </span>
                </div>
                <div className="card_body ">
                  <div className="recent_orders_content">
                    {recentOrderItems && <>
                      <div className="table_responsive">
                        <table className="table">
                          <tbody>
                          {recentOrderItems.map((order, recentItemIndex) => (
                              <tr key={`recent_order_${recentItemIndex}`}>
                                <td>
                                  <div className="name">{order?.customer?.fname} {order?.customer?.lname} <br/> <span>{order?.customer?.email}</span></div>
                                </td>
                                <td>
                                  <button type="button" className="btn btn_sm has_border_radius_15 btn_black">{order.payment_status ? order.payment_status : 'Pending'}</button>
                                </td>
                                <td className="text_right">
                                  ${order.total}
                                  <span className={'width_full'} style={{'fontSize': '10px'}}>{order.created_at}</span>
                                </td>
                              </tr>
                          ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                    }
                  </div>
                </div>
              </div>
            </div>

          </div>
        </>
        }


      </>
  );
};

export default HomePage;